"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _icon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/icon.css") : void 0);

var _menu = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/menu.css") : void 0);

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source), true)).call(_context2, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context3; _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _objectSpread(_objectSpread({}, _icon.default), _menu.default));

var MenuItem = function MenuItem(_ref) {
  var addonAfter = _ref.addonAfter,
      addonBefore = _ref.addonBefore,
      url = _ref.url,
      isLink = _ref.isLink,
      children = _ref.children,
      onClick = _ref.onClick,
      className = _ref.className,
      cssNamespace = _ref.cssNamespace,
      addonProps = _ref.addonProps,
      urlProps = _ref.urlProps,
      separator = _ref.separator,
      active = _ref.active,
      disabled = _ref.disabled,
      selected = _ref.selected,
      props = (0, _objectWithoutProperties2.default)(_ref, ["addonAfter", "addonBefore", "url", "isLink", "children", "onClick", "className", "cssNamespace", "addonProps", "urlProps", "separator", "active", "disabled", "selected"]);
  var linkClassNames = classnames("".concat(cssNamespace, "-menu__link"), {
    'is-active': active,
    'is-selected': selected,
    'is-disabled': disabled
  });
  var addonBeforeClassname = classnames("".concat(cssNamespace, "-menu__addon-before"));
  var addonAfterClassname = classnames("".concat(cssNamespace, "-menu__addon-after"));

  var renderLink = function renderLink() {
    if (url) {
      return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({}, urlProps, {
        className: linkClassNames,
        href: url,
        onClick: onClick,
        role: "menuitem"
      }), addonBefore && /*#__PURE__*/_react.default.createElement("span", {
        className: addonBeforeClassname
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({}, addonProps, {
        ariaHidden: true,
        glyph: addonBefore
      }))), /*#__PURE__*/_react.default.createElement("span", {
        className: classnames("".concat(cssNamespace, "-menu__title"))
      }, children), addonAfter && /*#__PURE__*/_react.default.createElement("span", {
        className: addonAfterClassname
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({}, addonProps, {
        ariaHidden: true,
        glyph: addonAfter
      }))));
    } else if (children && /*#__PURE__*/_react.default.isValidElement(children)) {
      var _context;

      var childrenClassnames = classnames(linkClassNames, children.props.className);
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, addonBefore && /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({}, urlProps, {
        className: addonBeforeClassname
      }), /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({}, addonProps, {
        ariaHidden: true,
        glyph: addonBefore
      }))), /*#__PURE__*/_react.default.createElement("span", {
        className: classnames("".concat(cssNamespace, "-menu__title"))
      }, (0, _map.default)(_context = _react.default.Children).call(_context, children, function (child) {
        return /*#__PURE__*/_react.default.cloneElement(child, _objectSpread({
          className: childrenClassnames
        }, urlProps));
      })), addonAfter && /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({}, urlProps, {
        className: addonAfterClassname
      }), /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({}, addonProps, {
        ariaHidden: true,
        glyph: addonAfter
      }))));
    } else if (children) {
      return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({}, urlProps, {
        className: linkClassNames,
        onClick: onClick,
        role: "menuitem"
      }), addonBefore && /*#__PURE__*/_react.default.createElement("span", {
        className: addonBeforeClassname
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({}, addonProps, {
        ariaHidden: true,
        glyph: addonBefore
      }))), /*#__PURE__*/_react.default.createElement("span", {
        className: classnames("".concat(cssNamespace, "-menu__title"))
      }, children), addonAfter && /*#__PURE__*/_react.default.createElement("span", {
        className: addonAfterClassname
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({}, addonProps, {
        ariaHidden: true,
        glyph: addonAfter
      }))));
    }
  };

  var listClassNames = classnames("".concat(cssNamespace, "-menu__item"), className);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("li", (0, _extends2.default)({}, props, {
    className: listClassNames,
    role: "presentation"
  }), renderLink()), separator && /*#__PURE__*/_react.default.createElement("span", {
    className: classnames("".concat(cssNamespace, "-menu__separator"))
  }));
};

MenuItem.displayName = 'Menu.Item';
process.env.NODE_ENV !== "production" ? MenuItem.propTypes = {
  /** Set to **true** to apply active style */
  active: _propTypes.default.bool,

  /** Name of the SAP icon to be applied as an add-on before the text */
  addonAfter: _propTypes.default.string,

  /** Name of the SAP icon to be applied as an add-on after the text */
  addonBefore: _propTypes.default.string,

  /** Additional props to be spread to the add-ons */
  addonProps: _propTypes.default.object,

  /** Node(s) to render within the component */
  children: _propTypes.default.node,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Set to **true** to mark component as disabled and make it non-interactive */
  disabled: _propTypes.default.bool,

  /** Set to **true** to style as a link */
  isLink: _propTypes.default.bool,

  /** Set to **true** to apply selected style */
  selected: _propTypes.default.bool,

  /** Set to **true** to place a separator after list item */
  separator: _propTypes.default.bool,

  /** Enables use of `<a>` element. Value to be applied to the anchor\'s `href` attribute.
   * Should use either `link` or `url`, but not both. */
  url: _propTypes.default.string,

  /** Additional props to be spread to the Menu Item links (when using `url`). */
  urlProps: _propTypes.default.object,

  /**
   * Callback function; triggered when the MenuItem (i.e. the `<a>` element) is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @returns {void}
  */
  onClick: _propTypes.default.func
} : void 0;

var _default = (0, _withStyles.default)(MenuItem);

exports.default = _default;